<template>
  <div v-if="data === 'main'">
    <b-taglist attached>
      <b-tag type="is-gold" :size="dataSize" :class="dataClass">Haupt</b-tag>
      <b-tag v-if="test" type="is-grey-2" :size="dataSize" :class="dataClass"
        >Test</b-tag
      >
    </b-taglist>
  </div>
  <div v-else-if="data === 'sub'">
    <b-taglist attached>
      <b-tag type="is-grey-1" :size="dataSize" :class="dataClass">Unter</b-tag>
      <b-tag v-if="test" type="is-grey-2" :size="dataSize" :class="dataClass"
        >Test</b-tag
      >
    </b-taglist>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: String,
    },
    test: {
      required: false,
      type: Boolean,
      default: false,
    },
    dataSize: {
      required: false,
      type: String,
      default: '',
    },
    dataClass: {
      required: false,
      type: String,
      default: '',
    },
  },
};
</script>
